<template>
  <div class="leftmenu">
    <div class="morelist">
      <div class="text" v-for="(nav, i) in list" :key="i" @click="navpath(nav, i)">
        <div class="titles" :class="{ navactive: nav.path == $route.path, towmenu: !nav.path }">
          <div class="left-title" style="display: flex;margin-left:5px;">
			  <strong class="left-title-img" :class="{ 'left-title-img_active': nav.path == $route.path}" v-if="nav.meta.icon">
				   <img   :src="nav.meta.icon" style=" width:20px;height: 20px;margin-right: 4px;" alt="" srcset="" />
			  </strong>
			 
            <!-- <svg-icon v-if="nav.meta.icon" :class="{ 'hi-svg': nav.path == $route.path }" :icon-class="nav.meta.icon"
              style="margin-right: 4px;font-size: 18px;color:#999;position: relative;top: 3px;"></svg-icon> -->
            <span v-else style="display: inline-block; width: 1em;height: 1em;position: relative;top: 3px;"></span>
            <span>{{ nav.meta.title }}</span> 
          </div>
          <span class="icons" :class="{ transition90: childindex == i || nav.isShow }"
            v-if="nav.children && nav.children.length > 0">
            <i class="el-icon-arrow-right"></i>
          </span>
          <div class="activeBack">{{ nav.meta.title }}</div>
        </div>

        <el-collapse-transition>
          <div class="flex-list" v-show="childindex == i || nav.isShow">
            <div v-for="(children, children_i) in nav.children" :key="children_i" style="width: 100%;">
              <div class="childtext" :class="{ navactive: children.path == $route.path }" v-if="children.meta.layout == 1"
                :key="children_i" @click.stop="threepath(children)">
                <span>{{ children.meta.title }}</span>
                <div class="activeBack">{{ children.meta.title }}</div>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import menuRuntime from "@/router/menuRuntime.js";
import { shouldLeavePluginForMenuClick } from "@/router/menuRuntime.core.js";
export default {
  data() {
    return {
      list: [],
      childindex: 0,
      userinfo: "",
      loading: true,
      isShow: true,
    };
  },
  computed: {
    menuTree() { return this.$store.getters.menuTree || []; },
    meun() { return this.menuTree.filter((i) => i.meta.layout == 1); },
  },
  created() {
    this.children_route();
  },
  mounted() {
    this.getInfo();
  },
  watch: {
    $route: function (newflag, oldflag) {
      this.children_route();
    },
  },
  methods: {
    //获取信息
    getInfo() {
      let info = JSON.parse(sessionStorage.getItem("userinfo"));
      if (info && info.roles && info.roles.length > 0) {
        let guard_name = "";
        if (info.roles[0].id == 59) {
          guard_name = "api";
        }
        if (info.roles[0].id == 22) {
          guard_name = "store_admin_user";
        }
        if (!guard_name) {
          return;
        }
        // this.loading = false;
        // this.axios
        //   .get("/api/me", {
        //     params: {
        //       guard_name: guard_name,
        //     },
        //   })
        //   .then((res) => {
        //     this.loading = true;
        //     if (res.code == 200) {
        //       this.userinfo = JSON.parse(JSON.stringify(res.data));
        //       sessionStorage.setItem("userinfo", JSON.stringify(res.data));
        //       if (res.data.unitid == 2) {
        //         sessionStorage.setItem("role_id", res.data.roles[0].id);
        //       }
        //     }
        //   });
      }
    },
    calclayout(arr) {
      console.log('%c [ arr ]-102', 'font-size:13px; background:#83f2a2; color:#c7ffe6;', arr)
      let count = 0;
      arr.forEach((item) => {
        if (item.layout == 1) {
          count++;
        }
      });
      if (count > 1) {
        return true;
      } else {
        return false;
      }
    },
    isPluginMenuActive() {
      return Boolean(
        sessionStorage.getItem("is_plugin") ||
        this.$store.state.pluginroute ||
        (this.$store.state.menu && this.$store.state.menu.activePluginId)
      );
    },
    //监控子路由
    children_route() {
      const root = this.findActiveRootMenu(this.menuTree);
      this.list = [];
      if (root && root.children && root.children.length) {
        root.children.forEach((child) => {
          if (child.meta.layout == 1) {
            this.list.push(child);
          }
        });
      }
      this.$store.commit("changeasideWidth", this.list.length > 0 ? 50 : 0);
    },
    routeTreeHasPath(item, path) {
      if (!item || !path) {
        return false;
      }
      if (item.path === path) {
        return true;
      }
      return (item.children || []).some((child) => this.routeTreeHasPath(child, path));
    },
    findActiveRootMenu(routes) {
      const matchedTitle = this.$route.matched[0] && this.$route.matched[0].meta ? this.$route.matched[0].meta.title : "";
      const menuRootPath = this.$route.meta && this.$route.meta.menuRootPath ? this.$route.meta.menuRootPath : "";
      const currentPath = this.$route.path;
      const routerName = this.$route.meta && this.$route.meta.router_name ? this.$route.meta.router_name : "";

      return (routes || []).find((item) => {
        return item.meta.title === matchedTitle ||
          this.routeTreeHasPath(item, menuRootPath) ||
          this.routeTreeHasPath(item, currentPath) ||
          (routerName && item.meta.router_name === routerName && menuRootPath && this.routeTreeHasPath(item, menuRootPath));
      }) || null;
    },
    //跳转
    meunlink(item, index) {
      if (this.isPluginMenuActive() && shouldLeavePluginForMenuClick(item, this.$route.path)) {
        menuRuntime.prepareLeavePlugin();
      }
      if (item.path) {
        if (item.path != this.$route.path) {
          if (sessionStorage.getItem("is_plugin")) { menuRuntime.prepareLeavePlugin(); }
          this.$router.push({
            path: item.path,
          });
          this.$store.commit("changeasideWidth", 0);
        }
      } else {
        if (item.children[0].path != this.$route.path) {
          for (let i = 0; i < item.children.length; i++) {
            let child = item.children[i];
            if (child.meta.layout == 1) {
              if (child.children) {
                this.childindex = 0;
                if (child.children[0].path == this.$route.path) {
                  return;
                }

                if (child.children[0].meta.props) {
                  this.$router.push({
                    path: child.children[0].path,
                    query: {
                      props: child.children[0].meta.props,
                    },
                  });
                  return;
                } else {
                  this.$router.push({
                    path: child.children[0].path,
                  });
                  return;
                }
              } else {
                this.childindex = -1;
                if (child.meta.props) {
                  this.$router.push({
                    path: child.path,
                    query: {
                      props: child.meta.props,
                    },
                  });
                } else {
                  this.$router.push({
                    path: child.path,
                  });
                }
                this.$store.commit("changeasideWidth", 50);
                return;
              }
            }
          }
          this.$store.commit("changeasideWidth", 0);
        }
      }
    },
    //二级菜单跳转
    navpath(item, index) {
      this.$set(this.list[index], "isShow", false);
      if (item.children) {
        if (this.childindex == index) {
          this.childindex = -1;
          // return
        } else {
          this.childindex = index;
        }
      } else {
        this.childindex = -1;
        if (item.path && item.path != this.$route.path) {
          if (item.meta.props) {
            this.$router.push({
              path: item.path,
              query: {
                props: item.meta.props,
              },
            });
          } else {
            this.$router.push({
              path: item.path,
            });
          }
        }
      }
    },
    //三级菜单跳转
    threepath(item) {
      if (item.path && item.path != this.$route.path) {
        if (item.meta.props) {
          this.$router.push({
            path: item.path,
            query: {
              props: item.meta.props,
            },
          });
        } else {
          this.$router.push({
            path: item.path,
          });
        }
      } else {
        let path = "";
        if (item.meta.level == 2) {
          if (item.children) {
            path = item.children[0].path;
          }
        }
        this.$router.push({
          path,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
	.left-title-img{
		display: flex;
		align-items: center;
	}
	.left-title-img img{
		position: relative;
		font-weight: 300;
		left: -100px;
		filter: drop-shadow(#999999 100px 0);
	}
	.left-title-img_active img{
		left: -100px;
		filter: drop-shadow(#006aff 100px 0) !important;
	}
::v-deep .el-icon-arrow-right:before {
  font-size: 14px;
}

.leftmenu {
  width: 160px;
  height: calc(100vh - 68px);
  // background: var(--nav,#1e222b);
  position: absolute;
  top: 68px;
  background: #fff;
}

.morelist {
  width: 100%;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  // padding-top: 60px;
  overflow-y: auto;
  z-index: 999;
  cursor: pointer;
  background: transparent;

  .text {
    color: #333;
    font-size: 14px;
    font-weight: normal;
    line-height: 40px;
    height: auto;
    overflow: hidden;
    user-select: none;
	// margin: 0 10px;
  }

  .titles:hover {
    color: #006aff;
	img{
		filter: drop-shadow(#006aff 100px 0) !important;
	}
	.left-title{
		color: #006aff;
	}
  }
 

  .titles {
    padding: 0 26px;
    display: flex;
    align-items: center;
    // color: var(--navFontDefault,#d8d7d7);
    color: #333;
    position: relative;

    .icons {
      margin-left: 4px;
      font-size: 14px;
      // color: var(--navFontDefault,#d8d7d7);
      color: #333;
      font-weight: 600;
      transition: all 0.3s;
      position: absolute;
      right: 25px;
    }

    .transition {
      transform: rotate(180deg);
    }
	.transition90 {
	  transform: rotate(90deg);
	}
  }

  .flex-list {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    // padding: 0 16px;
    box-sizing: border-box;
  }

  .childtext {
    width: 86px;
    font-size: 14px;
    color: #333;
    background: transparent;
    display: flex;
    justify-content: space-between;
    // margin-left: 27px;
	padding-left: 52px;
	width:100%;
    &.navactive {
      .activeBack {
        color: #006aff !important;
        padding: 0 !important;
        justify-content: flex-start !important;
      }
    }
  }

  .childtext:hover {
    color: #006aff;
  }

  .towmenu {
    // font-weight: bold;
    line-height: 40px;

    div {
      text-align: left !important;
      font-weight: normal;
      color: #333;
      // color: var(--navFontDefault,#d8d7d7);
    }
  }

  .towmenu:hover {
    color: #006aff !important;
  }

  .activeBack {
    display: none;
  }

  .navactive {
    height: 40px;
    line-height: 40px;
    position: relative;
    font-weight: bold;
	background-color: rgba(0, 122, 255, .03);
    span {
      display: none;
    }

    .activeBack {
      // padding: 0 15px;
      display: block;
      line-height: 40px;
      border-radius: 8px;
      color: #006aff !important;
      position: relative;
      left: 0;
      // background: rgba(45, 140, 240, 0.1) !important;
      // position: absolute;
      // top: 2px;
      // left: 5px;
      // right: 5px;
      // bottom: 2px;
      // z-index: 0;
    }
  }
}

.hi-svg {
  color: #479cf7 !important;
}
</style>
